const getUrl = (getOverride, path) => {
  if (getOverride) {
    return getOverride(path);
  }
  if (typeof window === "undefined") return void 0;
  return `${window.location.origin}/_serverless/ricos-giphy-proxy/${path}`;
};
const getGiphyProxyUrl = (getOverride, params) => {
  const url = getUrl(getOverride, params.path);
  if (!url) {
    return void 0;
  }
  const giphyUrl = new URL(url);
  if (params?.searchTag) {
    giphyUrl.searchParams.append("q", params.searchTag);
  }
  giphyUrl.searchParams.append("limit", params.limit.toString());
  giphyUrl.searchParams.append("offset", params.offset.toString());
  giphyUrl.searchParams.append("category", params.category);
  return giphyUrl;
};
export {
  getGiphyProxyUrl
};
//# sourceMappingURL=get-giphy-proxy-url.js.map
